import { arrayAtPolyfill, stringAtPolyfill } from "./polyfill.at";
import { promiseAnyPolyfill } from "./polyfill.promise.any";

export function initPolyfills() {
  arrayAtPolyfill();
  stringAtPolyfill();
  promiseAnyPolyfill();
}
